module.exports = __webpack_public_path__ + "img/twitch-lounge-bg.2bb857d8.jpg";